module.exports = __webpack_public_path__ + "img/8.999e5ae7.png";